import messages_en from "./i18n/en.json"
import messages_es from "./i18n/es.json"
import messages_pl from "./i18n/pl.json"

export const i18nMessages = {
    en: messages_en,
    es: messages_es,
    pl: messages_pl
}

export enum Locale { DE = "de", EN = "en", ES = "es", FR = "fr", IT = "it", PL = "pl", RU = "ru" }

export const LOCALE_FORMAT: Record<Locale, string> = {
    [Locale.DE]: "de-DE",
    [Locale.EN]: "en-GB",
    [Locale.ES]: "es-ES",
    [Locale.FR]: "fr-FR",
    [Locale.IT]: "it-IT",
    [Locale.PL]: "pl-PL",
    [Locale.RU]: "ru-RU"
}

/**
 * In some environments the argument may arrive with region subtag.
 * ie: Stripe webhooks
 */
export function getI18nMessages(locale: string) {
    const [lang] = locale.split("-")
    return (
        i18nMessages[locale] ||  // exact match
        i18nMessages[lang]   ||  // fallback to language subtag
        i18nMessages["en"]       // default fallback
    )
}